import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=2cb1ffa0&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=2cb1ffa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1ffa0",
  null
  
)

export default component.exports